/**
 * Obscures the phone number by replacing the middle 5 digits with X's.
 * We show the first 3 and last 2 digits regardless of the inclusion of country code.
 */
export default (phoneNumber: string): string => {
  if (!phoneNumber) {
    return;
  }

  const trimmedString = phoneNumber.replace(/ /g, '');

  // Special case for US/CAN numbers to show the area code
  if (trimmedString?.length >= 10) {
    return (
      trimmedString.substring(0, trimmedString.length - 7) +
      'XXXXX' +
      trimmedString.substring(trimmedString.length - 2, trimmedString.length)
    );
  } else {
    const firstTwoDigits = trimmedString.substring(0, 2);
    const lastTwoDigits = trimmedString.substring(trimmedString.length - 2);
    const middle = 'X'.repeat(Math.max(trimmedString.length - 4, 0));
    return firstTwoDigits + middle + lastTwoDigits;
  }
};
